import React from 'react'
import PropTypes from "prop-types";
import RichTypography from './RichTypography';

function ChartSection({ title, description, defaultColumnWidth, component, children }) {
  return (
    <div className='' style={{ position: "relative"}}>
      <RichTypography className='neutral-charcoal' style={{zIndex: 1}}>{title}</RichTypography>
      <div className='row justify-content-between'>
        <div className={`${defaultColumnWidth} py-3`} style={{zIndex: 1}}>
          <p className='neutral-charcoal'>{description}</p>
        </div>
        {component && <div className='col-12 col-md-12 col-lg-6 d-flex justify-content-center align-items-center'>
          {component}
        </div>}
      </div>
        {children}
    </div>
  )
}

ChartSection.propTypes = {
  title: PropTypes.string || PropTypes.node,
  description: PropTypes.string || PropTypes.node,
  component: PropTypes.node,
  children: PropTypes.node,
  defaultColumnWidth: PropTypes.string
};

ChartSection.defaultProps = {
  title: undefined,
  description: undefined,
  component: undefined,
  children: undefined,
  defaultColumnWidth: 'col-12 col-md-12 col-lg-6'

}

export default ChartSection;